export function quantityComponent(parentData: any, modelProp: string) {
    const data = {
        quantity: parentData[modelProp].quantity,
        quantityChanged: parentData[modelProp].quantityChanged,
        min: typeof parentData[modelProp].min === 'number' ? parentData[modelProp].min : 0,
        max: typeof parentData[modelProp].max === 'number' ? parentData[modelProp].max : 99,
        //options: [] as number[],
        canIncrease() {
            return this.quantity < this.max;
        },
        increaseQuantity() {
            if (this.canIncrease()) {
                this.quantity++;

                if (this.quantityChanged) {
                    this.quantityChanged();
                }
            }
        },
        canDecrease() {
            return this.quantity > this.min;
        },
        decreaseQuantity() {
            if (this.canDecrease()) {
                this.quantity--;

                if (this.quantityChanged) {
                    this.quantityChanged();
                }
            }
        },
        openNativeInput() {
            //const input = this.$el.parentElement.querySelector('.hidden-native-input') as HTMLSelectElement;
            //input.style.pointerEvents = 'all';
            //input.style.opacity = '1';
            //input.focus();
            //input.style.pointerEvents = 'none';
            //input.style.opacity = '0';
        },
        inputQuantityChanged(event: Event) {
            const next = parseInt((event.target as HTMLSelectElement).value, 10);
            if (!isNaN(next)) {
                this.quantity = next;
                if (this.quantityChanged) {
                    this.quantityChanged();
                }
            }
        },
        init() {
            //this.options = Array.from({ length: this.max - this.min + 1 }, (_, i) => i + this.min);
            parentData[modelProp] = this;
        }
    };

    return data;
}
